<template>
  <div style="height: 100%">
    <div class="zTreeDiv">
      <ul :id="initId ? item.id + filterId : item.id" class="ztree"></ul>
    </div>
    <div id="buildRmenu">
      <ul>
        <li id="addBuild">添加节点</li>
        <li id="updateBuild">修改名称</li>
        <li id="delBuild">删除节点</li>
        <li id="addTable" v-if="isAddTable">新增数据</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tree",
  components: {},
  data() {
    return {
      // tree实例
      zTeeObj: {},
      //   选中的id
      ids: [],
      // 右键选中的目标
      selectNode: null,
    };
  },
  props: {
    defaultChecked: {
      type: Array,
      default() {
        return [];
      },
    },
    chkStyle: {
      type: String,
      default() {
        return "checkbox";
      },
    },
    isAddTable:{
      type: Boolean,
      default() {
        return true;
      },
    },
    filterId: {
      type: String,
      default() {
        return "filterId";
      },
    },
    initId: {
      type: Boolean,
      default() {
        return true;
      },
    },
    treeData: {
      type: Array,
      default() {
        return [];
      },
    },
    showRightClick: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isAllchecked: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isCheck: {
      type: Boolean,
      default() {
        return true;
      },
    },
    enable: {
      type: Boolean,
      default() {
        return false;
      },
    },
    item: {
      type: Object,
      default() {
        return {
          parentName: "",
          id: "",
          name: "",
        };
      },
    },
  },
  computed: {},
  watch: {
    treeData: {
      handler(a, b) {
        if (b) {
          this.initTree();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async initTree() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
          showIcon: true,
        },
        check: {
          enable: _this.isCheck,
          chkStyle: _this.chkStyle,
        },
        data: {
          key: {
            name: _this.item.name,
          },
          simpleData: {
            enable: true,
            idKey: _this.item.id,
            pIdKey: _this.item.parentName,
          },
        },
        edit: {
          enable: _this.enable,
          showRemoveBtn: false,
          showRenameBtn: false,
        },
        callback: {
          onRightClick: _this.showRightClick ? OnRightClick : "",
          beforeRename: beforeRename,
          onCheck: onCheck,
          onClick: onclick,
          beforeDrop: _this.showRightClick ? beforeDrop : "",
        },
      };
      this.zTeeObj = $.fn.zTree.init(
        $(`#${_this.initId ? _this.item.id + _this.filterId : _this.item.id}`),
        setting,
        _this.treeData
      );
      let allNodelist = [];
      getAllnode(this.zTeeObj.getNodes());
      function getAllnode(data) {
        data.forEach((el) => {
          if (el.children) {
            allNodelist.push(el);
            getAllnode(el.children);
          } else {
            allNodelist.push(el);
          }
        });
      }
      if (_this.defaultChecked.length) {
        allNodelist.forEach((el) => {
          if (_this.defaultChecked.some((k) => k == el[_this.item.id])) {
            this.zTeeObj.checkNode(el, true);
          }
        });
      } else {
        this.zTeeObj.checkAllNodes(_this.isAllchecked);
      }

      this.zTeeObj.expandAll(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      let idlist = [];
      checkedNodes.forEach((element) => {
        idlist.push(element[_this.item.id]);
      });
      _this.ids = idlist;
      idlist.length ? _this.updateIds(_this.ids) : "";
      // 选中状态
      function onCheck(event, treeId, treeNode) {
        var checkedNodes = _this.zTeeObj.getCheckedNodes(true);
        _this.ids = checkedNodes.map((el) => el[_this.item.id]);
        _this.updateIds(_this.ids);
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.updateIds([treeNode[_this.item.id]], 'Onclick');
      }

      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
            return false;
          case "next":
          case "inner":
            _this.upDrop({ moveNode, targetNode, moveType });
            return true;
        }
        return false;
      }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY - 60);
        } else {
          showRMenu("node", event.clientX, event.clientY - 60);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "buildRmenu" ||
            $(event.target).parents("#buildRmenu").length > 0
          )
        ) {
          $("#buildRmenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $("#addBuild").show();
          $("#addTable").hide();
          $("#updateBuild").hide();
          $("#delBuild").hide();
        } else {
          $("#addBuild").show();
          $("#addTable").show();
          $("#updateBuild").show();
          $("#delBuild").show();
        }
        $("#buildRmenu").show();
        $("#buildRmenu").css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $("#buildRmenu ul li")
        .unbind()
        .bind("click", function () {
          $("#buildRmenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addBuild") {
            _this.$emit("addTree", _this.selectNode, _this.zTeeObj);
          } else if (type == "delBuild") {
            let selectIds = [];
            _this.zTeeObj.transformToArray(_this.selectNode).forEach((v) => {
              selectIds.push(v[_this.item.id]);
            });
            selectIds = selectIds.join(",");
            _this.$emit("delTree", selectIds, _this.selectNode, _this.zTeeObj);
          } else if (type == "addTable") {
            _this.$emit("addTable", { ..._this.selectNode });
          } else {
            _this.zTeeObj.editName(_this.selectNode);
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode[_this.item.name]) {
          _this.$emit("editTree", { newName, treeNode });
          //   let params = {
          //     id: treeNode.dept01,
          //     name: newName,
          //   };
        }
      }
    },
    getData() { },
    updateIds(id, type) {
      this.$emit("updateIds", id, type);
    },
    getIds() {
      this.$emit("updateIds", this.ids);
    },
    upDrop(data) {
      this.$emit("upDrop", { ...data });
    },
    checkAllNodes(isAllchecked) {
      this.zTeeObj.checkAllNodes(isAllchecked);
      let ids = this.zTeeObj.getNodes().map((i) => i[this.item.id]);
      this.updateIds(ids);
    },
  },
  created() {
  },
  mounted() {
    this.initTree();
  },
};
</script>
<style lang='less' scoped>
#buildTree {
  // height: 500px;
  height: 100%;
}

.zTreeDiv {
  width: 100%;
  height: 97%;
  max-height: 550px;
  overflow: auto;
}

.ztree {
  // height: 97%;
  min-height: 480px;
}

.ztree li span {
  color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

div#buildRmenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #73b4af;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#buildRmenu ul {
  margin: 0px;
  padding: 0px;
}

div#buildRmenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#buildRmenu ul li:hover {
  background: #eee;
  color: #000000;
}</style>